/**
 * FreeSpinsIntroOutroView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsIntroOutro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      this._youHaveWonText = undefined;
      this._fsCountFrame = undefined;
      this._spinsWon = undefined;
      this._freeSpinsIntroAnimatedPanel = undefined;
      this._outroCashPanel = undefined;
      this._cashWon = undefined;

      this._freeSpinsText = undefined;
      this._congratulationsText = undefined;
      this._youHaveWonFsWinningsText = undefined;
      this._fromFreeSpinsText = undefined;

      this._pressStartBox = undefined;
      this._introActive = false;
    }

    initialise() {
      const self = this;

      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._gambleBacker = resourceManager.get('gambleBacker');
      this._fullPanel = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro');
      this._youHaveWonText = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:youHaveWonText');
      this._youHaveWonText.visible = false;

      this._fsCountFrame = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:fsCountFrame');
      this._fsCountFrame.visible = false;

      this._spinsWon = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:numFreeSpinsText');
      this._spinsWon.visible = false;

      this._freeSpinsIntroAnimatedPanel = resourceManager.get(
        'freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:gambleIntroAnimatedPanel'
      );

      this._outroCashPanel = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroCashPanel');
      this._outroCashPanel.visible = false;

      this._cashWon = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:cashWonText');
      this._cashWon.visible = false;

      this._freeSpinsText = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:freespinsText');
      this._freeSpinsText.visible = false;

      this._congratulationsText = resourceManager.get(
        'freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:congratulationsText'
      );
      this._congratulationsText.visible = false;

      this._youHaveWonFsWinningsText = resourceManager.get(
        'freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:youHaveWonFsWinningsText'
      );
      this._youHaveWonFsWinningsText.visible = false;

      this._fromFreeSpinsText = resourceManager.get(
        'freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:fromFreespinsText'
      );
      this._fromFreeSpinsText.visible = false;

      this._pressStartBox = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:pressStartColourBox');

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;
    }

    setup() {
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
    }

    showIntro(numFS, callback) {
      this._introActive = true;
      this.setup();

      this._callback = callback;
      this._youHaveWonText.visible = true;
      this._fsCountFrame.visible = true;
      this._spinsWon.visible = true;
      this._freeSpinsText.visible = true;
      this._freeSpinsIntroAnimatedPanel.play();
      this._congratulationsText.visible = false;
      this._youHaveWonFsWinningsText.visible = false;
      this._outroCashPanel.visible = false;
      this._cashWon.visible = false;

      this._fromFreeSpinsText.visible = false;

      this._spinsWon.text = numFS;

      //this.bounceIn(this._youHaveWonText);
      //this.bounceIn(this._fsCountFrame);
      //this.bounceIn(this._spinsWon);
      //this.bounceIn(this._freeSpinsText);

      this.floatIn(this._fullPanel, 0, 3);
      this.fadeIn(this._fullPanel, 1.0, 1.0, 0);

      let self = this;
      timerManager.addTimeout(1500, function () {
        self.setActive();
      });

      soundManager.play('dialogIn');

      game.autoClickForReplayRewatchTimer(() => {
        self.closeDialog();
      });

      //resourceManager.get("trail:TrailContainer").switchTrail("trailX3");
    }

    floatIn(object, delay, duration) {
      gsap.fromTo(
        object,
        {
          x: 0,
          y: 500,
        },
        {
          delay,
          duration,
          ease: 'elastic.out(1.0, 0.3)',
          x: 0,
          y: 0,
          onStart: () => {
            this._fullPanel.visible = true;
          },
          onComplete: () => {
            //this.setActive(); moved to timer
          },
        }
      );
    }

    fadeIn(object, alpha, duration, delay) {
      gsap.fromTo(
        object,
        {
          alpha: 0,
        },
        {
          delay: delay,
          duration: duration,
          alpha: alpha,
          onStart: () => {
            object.visible = true;
          },
        }
      );
    }

    bounceIn(object, delay, duration, scale) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: duration ?? 1,
          ease: 'Bounce.easeOut',
          x: scale ?? 1,
          y: scale ?? 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }

    setActive() {
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.closeDialog.bind(this);
    }

    showOutro(cashWon, callback) {
      let self = this;

      gameController.fullScreenBubblesFront.startBubbles();

      timerManager.addTimeout(200, function () {
        gameController.fullScreenBubblesFront.stopBubbles();
      });

      gameController.fullScreenBubblesBack.startBubbles();

      musicManager.onPlayBubbleIntro();

      gameData.topLayerMeters.visible = true;

      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      this._introActive = false;
      this._fullPanel.visible = true;
      this.setup();

      this._callback = callback;

      this._spinsWon.visible = false;
      this._youHaveWonText.visible = false;
      this._fsCountFrame.visible = false;

      this._freeSpinsIntroAnimatedPanel.stop();
      this._outroCashPanel.visible = true;
      this._cashWon.visible = true;
      this._fromFreeSpinsText.visible = true;
      this._congratulationsText.visible = true;
      this._youHaveWonFsWinningsText.visible = true;
      this._freeSpinsText.visible = false;

      this.floatIn(this._fullPanel, 0, 3);
      this.fadeIn(this._fullPanel, 1.0, 1.0, 0);

      soundManager.play('free_spins_end');

      timerManager.addTimeout(1500, function () {
        self.setActive();
      });

      this._cashWon.setText(gdk.formatCurrency(cashWon));

      game.autoClickForReplayRewatchTimer(() => {
        self.closeDialog();
      });
    }

    closeDialog() {
      let reels = resourceManager.get('slotContainer:reelContainer');
      reels.alpha = 1.0;
      // turn off click processing
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      soundManager.play(soundManifest.getSound('buttonPress'));
      soundManager.play('dialogOut');

      if (this._introActive) {
        this.clearIntro();
      } else {
        this.clearOutro();
      }
    }

    clearIntro() {
      game.stopAutoClickForReplayRewatch();

      gameController.fullScreenBubblesBack.stopBubbles();
      this.fadeOut(this._gambleBacker, 1.0);
      this.riseUp(this._fullPanel, 1.0);
      gameData.topLayerMeters.visible = false;

      const self = this;
      timerManager.addTimeout(1000, function () {
        self._callback();
      });
    }

    clearOutro() {
      game.stopAutoClickForReplayRewatch();

      gameController.fullScreenBubblesFront.stopBubbles();
      gameController.fullScreenBubblesBack.stopBubbles();
      gameData.topLayerMeters.visible = false;

      this.fadeOut(this._gambleBacker, 1.0);
      this.riseUp(this._fullPanel, 1.0);

      const self = this;
      timerManager.addTimeout(1500, function () {
        self._callback();
      });
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: 'power1.in',
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;
        },
      });
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, 'x'),
        y: gsap.getProperty(object, 'y'),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: 'power4.in',
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }
        },
      });
    }
  }

  let freeSpinsIntroOutroCreator = function (json) {
    return new FreeSpinsIntroOutro();
  };

  let freeSpinsIntroOutroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let freeSpinsIntroOutroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    'FreeSpinsIntroOutro',
    freeSpinsIntroOutroCreator,
    freeSpinsIntroOutroInitialiser,
    freeSpinsIntroOutroFilesRequired
  );
})();
